import { httpGet } from '@/api/httpClient';

export type SuperTopologyDebugApartment = {
  id: number;
  name: string;
  code: string;
  boxCount: number;
  deviceCount: number;
  attributeCount: number;
};

export type SuperTopologyDebugRoom = {
  id: number;
  name: string;
  code: string;
  deviceCount: number;
  attributeCount: number;
};

export type SuperTopologyDebugBox = {
  id: number;
  name: string;
  code: string;
  areaCount: number;
};

export type SuperTopologyDebugDevice = {
  id: number;
  name: string;
  code: string;
  boxId: number;
  areaCount: number;
};

export type SuperTopologyDebugAttribute = {
  id: number;
  name: string;
  deviceId: number;
  deviceName: string | null;
  attributeTypeCode: string | null;
  lastValue: string | null;
  lastTimestampSec: number | null;
  areaCount: number;
};

export type SuperTopologyDebugDeviceAttributesLastResponse = {
  projectId: number;
  deviceId: number;
  count: number;
  attributes: {
    id: number;
    name: string;
    attributeTypeCode: string | null;
    lastValue: string | null;
    lastTimestampSec: number | null;
  }[];
};

export type SuperTopologyDebugAreasDuplicateDevicesResponse = {
  projectId: number;
  deviceTypeId: number;
  areaTypeId: number;
  count: number;
  areas: {
    id: number;
    name: string;
    code: string;
    areaTypeCode: string | null;
    areaTypeTitle: string | null;
    deviceCount: number;
    devices: string;
  }[];
};

export type SuperTopologyDebugResponse = {
  projectId: number;
  generatedAt: string;
  limit: number;
  apartments: SuperTopologyDebugApartment[];
  rooms: SuperTopologyDebugRoom[];
  boxes: SuperTopologyDebugBox[];
  devices: SuperTopologyDebugDevice[];
  attributes: SuperTopologyDebugAttribute[];
};

export const superTopologyDebugApi = {
  getOrphans: (projectId: number) =>
    httpGet<SuperTopologyDebugResponse>(`/admin/super-topology-debug/projects/${projectId}/orphans`),
  getDeviceAttributesLast: (projectId: number, deviceId: number) =>
    httpGet<SuperTopologyDebugDeviceAttributesLastResponse>(
      `/admin/super-topology-debug/projects/${projectId}/devices/${deviceId}/attributes-last`
    ),
  getAreasDuplicateDevices: (projectId: number, deviceTypeId: number, areaTypeId: number) =>
    httpGet<SuperTopologyDebugAreasDuplicateDevicesResponse>(
      `/admin/super-topology-debug/projects/${projectId}/areas-duplicate-devices`,
      { deviceTypeId, areaTypeId }
    ),
};

